import { Button, Checkbox, Col, DatePicker, Input, Row, Select } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { closeFilter, onChange, onReset, onSubmit, getListChannelOrder } from './../../../../actions/ordersAction';
import { convertDateToUTC } from './../../../../services/dst';
import { CheckFullSizeHalfSize, renderSelectAntTitle } from './../../../../services/helper';
import { orderStatus, FulfillOption as FulfillOptionConst } from './../../../../constants';
import './styles.css';

const Option = Select.Option;
const CheckboxGroup = Checkbox.Group
const options = [
    { label: 'Awaiting Finalization', value: orderStatus.AWAITING_FINALIZATION },
    { label: 'Awaiting Shipment', value: orderStatus.AWAITING_SHIPMENT },
    { label: 'Sent to Shipment', value: orderStatus.SENT_TO_SHIPMENT },
    { label: 'Split', value: orderStatus.SPLIT },
]
const optionsType = [
    { label: 'Imported', value: 1 },
    { label: 'Manual', value: 2 },
]

const optionsFulfillment = [
    { label: FulfillOptionConst.YAMATO.NAME, value: FulfillOptionConst.YAMATO.CODE },
    { label: FulfillOptionConst.IN_HOUSE.NAME, value: FulfillOptionConst.IN_HOUSE.CODE },
]
const dateFormat = 'MM/DD/YYYY';

class AddFilter extends Component {
    constructor(props) {
        super(props)
        this.state = {};
        this.selectChannelOptionPlace = this.selectChannelOptionPlace.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        if (props.add_filter) {
            let filter = document.querySelector('.add-filter')
            if (filter) {
                filter.onkeydown = function (e) {
                    if (e.key === 'Enter') {
                        document.getElementsByClassName('display')[0].click()
                    }
                }
            }
        }
        return null
    }

    componentDidMount() {
        this.props.getListChannelOrder()
    }

    onChange = (value, maxLength) => {
        let wordMax = CheckFullSizeHalfSize(value, maxLength)
        if (!wordMax) return;
        this.props.onChange({ value: value, column: 'channel_order_no' })
    }

    renderListChannel = () => {
        return this.props.ordersReducer.listChannel.map((e, i) => {
            return (
                <Option key={i} value={String(e.ID)}>{e.Name}</Option>
            )
        })
    }

    submitFilter = () => {
        this.props.onSubmit({ ...this.props.getOrderParams, Page: 1, SelectedIds: [] })
    }

    /**
     * filter option for select channel
     */
    selectsFilterChannel = (inputValue, option) => {
        if (option.props.children.toLowerCase().indexOf(inputValue.toLowerCase()) > -1) {
            return true;
        }
        return false;
    }

    /**
     * custom show text and title select channel if chooes multi channel
     */
    selectChannelOptionPlace = (omittedValues) => {
        return renderSelectAntTitle(omittedValues, this.props.ordersReducer.listChannel);
    }

    handleFilterChannel = (e) => {
        let maxTagCount = 2;
        if(e.length > 2) {
            maxTagCount = 1
        }
        this.props.onChange({ value: e, column: 'channel' })
        this.props.onChange({ value: maxTagCount, column: 'maxTagCount' })
    }

    render() {
        if (this.props.add_filter) {
            return (
                <Col span={24}>
                    <div className="add-filter">
                        <Row>
                            <Col span={3}>
                                <h3>Add Filters</h3>
                            </Col>

                            <Col span={1} offset={20}>
                                <span className='close-filter'
                                    style={{ float: 'right', cursor: 'pointer' }}
                                    onClick={() => {
                                        this.props.closeFilter()
                                    }}>X</span>
                            </Col>
                        </Row>
                        <Row gutter={16} type="flex">
                            <Col span={24}>
                                <Row gutter={16}>
                                    <Col span={3}>
                                        <div className="filter-title">
                                            <span>Channel</span>
                                        </div>
                                        <div className="filter-channel filter-status">
                                            <Select
                                                className="select-filter-multi"
                                                mode="multiple"
                                                style={{ width: '100%' }}
                                                placeholder="Select Channel"
                                                onChange={this.handleFilterChannel}
                                                value={this.props.sub_input_filter.channel}
                                                maxTagCount={this.props.sub_input_filter.maxTagCount}
                                                filterOption={this.selectsFilterChannel}
                                                maxTagPlaceholder={this.selectChannelOptionPlace}
                                            >
                                               {this.renderListChannel()}
                                            </Select>
                                        </div>
                                    </Col>
                                    <Col span={3}>
                                        <div className="filter-title">
                                            <span>Channel Order #</span>
                                        </div>
                                        <div className="filter-channel-orders">
                                            <Input
                                                size="small"
                                                value={this.props.sub_input_filter.channel_order_no}
                                                onChange={e => this.onChange(e.target.value, 60)}
                                            />
                                        </div>
                                    </Col>
                                    
                                    <Col span={4}>
                                        <div className="filter-title">
                                            <span>Type</span>
                                        </div>
                                        <div className="filter-status filter-status-type">
                                            <CheckboxGroup
                                                options={optionsType}
                                                defaultValue={this.props.sub_input_filter.type_list}
                                                value={this.props.sub_input_filter.type_list}
                                                onChange={e => this.props.onChange({ value: e, column: 'type_list' })}
                                            />
                                        </div>
                                    </Col>
                                    <Col span={13}>
                                        <div className="filter-title">
                                            <span>Status</span>
                                        </div>
                                        <div className="filter-status">
                                            <CheckboxGroup
                                                options={options}
                                                defaultValue={this.props.sub_input_filter.status_list}
                                                value={this.props.sub_input_filter.status_list}
                                                onChange={e => this.props.onChange({ value: e, column: 'status_list' })}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row gutter={16} className="box-filter-2">
                                    <Col span={7}>
                                        <div className="filter-title">
                                            <span>Order Date</span>
                                        </div>
                                        <div className="filter-date-order">
                                            <span className='label-time'>From &nbsp;</span>
                                            <DatePicker
                                                size={'small'}
                                                value={this.props.sub_input_filter.from ? moment(this.props.sub_input_filter.from, dateFormat) : null}
                                                onChange={(e, eToString) => this.props.onChange({ value: eToString, column: 'from' })}
                                                format={dateFormat}
                                            />
                                            <span className='label-time'>&nbsp;To &nbsp;</span>
                                            <DatePicker
                                                size={'small'}
                                                value={this.props.sub_input_filter.to ? moment(this.props.sub_input_filter.to, dateFormat) : null}
                                                onChange={(e, eToString) => this.props.onChange({ value: eToString, column: 'to' })}
                                                format={dateFormat}
                                            />
                                        </div>
                                    </Col>
                                    { this.props.FulfillmentFlg ? 
                                        <Col span={6}>
                                            <div className="filter-title">
                                                <span>Fulfillment Option</span>
                                            </div>
                                            <div className="filter-fulfillment-option">
                                                <CheckboxGroup
                                                    options={optionsFulfillment}
                                                    defaultValue={this.props.sub_input_filter.fulfill_option}
                                                    value={this.props.sub_input_filter.fulfill_option}
                                                    onChange={e => this.props.onChange({ value: e, column: 'fulfill_option' })}
                                                />
                                            </div>
                                        </Col>
                                        : ""
                                    }
                                    

                                </Row>
                            </Col>
                        </Row>
                        <Row className="btn-action">
                            <Col span={6} offset={9}>
                                <Button
                                    htmlType="reset"
                                    className="clear"
                                    size="large"
                                    onClick={() => this.props.onReset({ PageSize: this.props.getOrderParams.PageSize })}
                                >Reset</Button>
                                <Button
                                    htmlType="submit"
                                    className="display ant-btn-primary"
                                    size="large"
                                    onClick={() => this.submitFilter()}
                                >Apply</Button>
                            </Col>
                        </Row>
                    </div>
                </Col>
            )
        } else return null
    }
}

const mapStateToProps = state => {
    return {
        add_filter: state.ordersReducer.add_filter,
        sub_input_filter: state.ordersReducer.sub_input_filter,
        orderBy: state.ordersReducer.orderBy,
        isDesc: state.ordersReducer.isDesc,
        ordersReducer: state.ordersReducer,
        getOrderParams: {
            Status: state.ordersReducer.sub_input_filter.status_list,
            FulfillOption: state.ordersReducer.sub_input_filter.fulfill_option,
            Type: state.ordersReducer.sub_input_filter.type_list,
            OrderDateFrom: convertDateToUTC(new Date(state.ordersReducer.sub_input_filter.from + ' 00:00:00')),
            OrderDateTo: convertDateToUTC(new Date(state.ordersReducer.sub_input_filter.to + ' 23:59:59')),
            OrderBy: state.ordersReducer.orderBy,
            IsDesc: state.ordersReducer.isDesc,
            PageSize: state.ordersReducer.offset,
            Page: state.ordersReducer.current_page,
            ChannelOrderID: state.ordersReducer.sub_input_filter.channel_order_no,
            ChannelID: state.ordersReducer.sub_input_filter.channel,
        },
        FulfillmentFlg: state.headerReducer.Summary.FulfillmentFlg
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChange: payload => {
            dispatch(onChange(payload))
        },
        onSubmit: payload => {
            dispatch(onSubmit(payload))
        },
        onReset: payload => {
            dispatch(onReset(payload))
        },
        closeFilter: () => {
            dispatch(closeFilter())
        },
        getListChannelOrder: () => {
            dispatch(getListChannelOrder())
        }
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddFilter)



// WEBPACK FOOTER //
// ./src/containers/orders/components/add-filter/index.js